export default {
  fonts: {
    body: 'Varela Round',
  },
  colors: {
    primary: '#67BA58',
    background: '#FFFFFF',
    shape: `#F2F2FA`,
    title: `#3D3D4D`,
    text: `#6C6C80`,
    components: {
      blockquote: {
        background: `#EBF9E9`,
        text: `#6C6C80`,
      },
    },
  },
};
